/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/scripts/snippets/cart-page-redirect.js":
/*!****************************************************!*\
  !*** ./src/scripts/snippets/cart-page-redirect.js ***!
  \****************************************************/
/***/ (function() {

eval("/**\n * Section: Cart page\n * ------------------------------------------------------------------------------\n * This re-directs the user from the cart page and back to the homepage.\n *\n */\nif (window.location.pathname.includes('/cart')) {\n  window.location.replace('/?showCart=true');\n}\n\n//# sourceURL=webpack://gibson-dev/./src/scripts/snippets/cart-page-redirect.js?");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module can't be inlined because the eval devtool is used.
/******/ 	var __webpack_exports__ = {};
/******/ 	__webpack_modules__["./src/scripts/snippets/cart-page-redirect.js"]();
/******/ 	
/******/ })()
;